import "./App.scss";
import { ToastContainer } from "react-toastify";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { HomePage } from "./pages/homepage";
import Layout from "./components/appLayout/layout";
import ContactSection from "./pages/contactPage";
import { LanguageProvider } from "./contexts/LanguageContext";

function App() {
  return (
    <LanguageProvider>
      {/* Ton contenu */}
      <ToastContainer position="top-right" />
      <Router>
        <Routes>
          <Route
            path="/"
            element={
              <Layout>
                <HomePage />
              </Layout>
            }
          />
          <Route
            path="/contact"
            element={
              <Layout>
                <ContactSection />
              </Layout>
            }
          />
        </Routes>
      </Router>
    </LanguageProvider>
  );
}

export default App;
